import { Box, Tooltip, Typography } from "@mui/material";
import dayjs from "dayjs";

export default function GapGridItem({
  startDate,
  endDate,
  title = "Huidige voorraad uitverkocht",
}) {
  const gridStart = dayjs().startOf("day"); // of bijvoorbeeld een vaste datum
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  return (
    <Box>
      <Typography variant={"subtitle2"}>{title}</Typography>
      <div
        style={{
          display: "flex",
          width: "100%",
        }}
      >
        {Array.from({ length: 120 }).map((_, i) => {
          const date = gridStart.add(i, "day");
          console.log(date);

          const formatted = date.format("DD-MM-YY");

          const isActive = date.isBefore(end) && date.isAfter(start);

          return (
            <div
              key={i}
              style={{
                flex: `0 0 ${100 / 120}%`,
                aspectRatio: "1",
                boxSizing: "border-box",
                padding: "1px",
              }}
            >
              <Tooltip title={formatted} arrow>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundColor: isActive ? "#4caf50" : "#ccc",
                    borderRadius: "2px",
                  }}
                />
              </Tooltip>
            </div>
          );
        })}
      </div>
    </Box>
  );
}
